import { apmLatencyTracker } from './apm-latency-tracker';

let appStartTime: number | null = null;

export function startMeasuringPerformance() {
  if (appStartTime === null) {
    console.log('Starting performance measurement');
    appStartTime = performance.now();
    apmLatencyTracker.init();
  }
}

export function logPerformance(message: string) {
  if (appStartTime === null) {
    return;
  }
  const duration = performance.now() - appStartTime;
  const durationInSeconds = (duration / 1000).toFixed(2);
  console.log(`${message} Loaded in: ${durationInSeconds}s`);
}
